export const DEMO_WORK_ORDERS: any[] = [
  {
    id: '1',
    work_order_code: 'CV-2024-0156',
    title: 'Trồng cây xanh tuyến đường chính',
    description: 'Trồng mới cây xanh bóng mát dọc tuyến đường chính trong dự án. Đảm bảo đúng chủng loại, khoảng cách.',
    status: 'in_progress',
    status_label: 'Đang thực hiện',
    priority: 'high',
    type: 'construction',
    projectName: 'Khu đô thị Eco Garden',
    workTypeLabel: 'Trồng cây',
    leadName: 'Trần Minh Tuấn',
    leadAvatar: 'https://ui-avatars.com/api/?name=Tran+Minh+Tuan&background=0284c7&color=fff',
    dueDate: '25/05/2024',
    progress: 60,
    startDate: '20/05/2024',
    endDate: '30/05/2024',
    notes: 'Cần đảm bảo nguồn nước tưới cho cây trong 7 ngày đầu.'
  },
  {
    id: '2',
    work_order_code: 'CV-2024-0157',
    title: 'Cắt tỉa cây xanh khu A',
    description: 'Cắt tỉa tạo tán cho hệ thống cây xanh bóng mát khu A.',
    status: 'overdue',
    status_label: 'Quá hạn',
    priority: 'medium',
    type: 'maintenance',
    projectName: 'Công viên Central Park',
    workTypeLabel: 'Cắt tỉa',
    leadName: 'Lê Hoàng Nam',
    leadAvatar: 'https://ui-avatars.com/api/?name=Le+Hoang+Nam&background=e11d48&color=fff',
    dueDate: '20/05/2024',
    progress: 90,
    startDate: '15/05/2024',
    endDate: '20/05/2024',
  },
  {
    id: '3',
    work_order_code: 'CV-2024-0158',
    title: 'Lắp đặt hệ thống tưới tự động',
    description: 'Lắp đặt đường ống và vòi phun cho khu vực thảm cỏ phía Tây.',
    status: 'in_progress',
    status_label: 'Đang thực hiện',
    priority: 'high',
    type: 'construction',
    projectName: 'Khu đô thị Eco Garden',
    workTypeLabel: 'Hệ thống tưới',
    leadName: 'Phạm Văn Tài',
    leadAvatar: 'https://ui-avatars.com/api/?name=Pham+Van+Tai&background=059669&color=fff',
    dueDate: '30/05/2024',
    progress: 35,
    startDate: '22/05/2024',
    endDate: '30/05/2024',
  },
  {
    id: '4',
    work_order_code: 'CV-2024-0159',
    title: 'Vệ sinh, làm cỏ khu vực hồ điều hòa',
    description: 'Vệ sinh rác thải và nhổ cỏ dại khu vực quanh hồ.',
    status: 'completed',
    status_label: 'Hoàn thành',
    priority: 'low',
    type: 'maintenance',
    projectName: 'Công viên Central Park',
    workTypeLabel: 'Vệ sinh cảnh quan',
    leadName: 'Nguyễn Thị Hương',
    leadAvatar: 'https://ui-avatars.com/api/?name=Nguyen+Thi+Huong&background=8b5cf6&color=fff',
    dueDate: '22/05/2024',
    progress: 100,
    startDate: '21/05/2024',
    endDate: '22/05/2024',
  },
  {
    id: '5',
    work_order_code: 'CV-2024-0160',
    title: 'Kiểm tra, bảo dưỡng đèn chiếu sáng',
    description: 'Kiểm tra hệ thống điện và thay thế bóng đèn hỏng.',
    status: 'not_started',
    status_label: 'Chưa bắt đầu',
    priority: 'medium',
    type: 'maintenance',
    projectName: 'Khu dân cư Happy Home',
    workTypeLabel: 'Bảo dưỡng hệ thống',
    leadName: 'Đỗ Văn Hùng',
    leadAvatar: 'https://ui-avatars.com/api/?name=Do+Van+Hung&background=f59e0b&color=fff',
    dueDate: '28/05/2024',
    progress: 0,
    startDate: '28/05/2024',
    endDate: '29/05/2024',
  }
];
